export const POWER_PRICE_COLOR = '#88ADA4'
